import type { Component, ComputedRef, PropType, VNode } from 'vue';
import { defineComponent, h, isRef } from 'vue';

export const ComponentWrapper = (name: string) =>
    defineComponent({
        name,
        props: {
            component: { type: Object as PropType<Component>, required: true },
            renderSlots: Object as PropType<Record<string, () => VNode>>,
            params: {
                type: Object as PropType<Record<string, unknown> | ComputedRef<Record<string, unknown>>>,
                required: true,
            },
        },
        setup(props) {
            return () =>
                h(
                    // @ts-ignore
                    props.component,
                    isRef(props.params) ? props.params.value : props.params,
                    props.renderSlots ? props.renderSlots : ['No content']
                );
        },
    });
